// extracted by mini-css-extract-plugin
export default {"payment-confirmation":"PaymentDetails_payment-confirmation__gH2T7","payment-confirmation-container":"PaymentDetails_payment-confirmation-container__uziLT"};